module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_247.5deg.5452cbdf.png";